import React from "react";
import { colors } from "../../constants/theme";

interface TextInputProps {
  label?: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  multiline?: boolean;
  rows?: number;
  style?: React.CSSProperties;
}

export const TextInput: React.FC<TextInputProps> = ({ label, value, onChange, placeholder, multiline, rows = 3, style }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 6, ...style }}>
    {label && <label style={{ color: colors.muted, fontSize: 12 }}>{label}</label>}
    {multiline ? (
      <textarea value={value} onChange={(e) => onChange(e.target.value)} rows={rows} placeholder={placeholder} style={{ resize: "vertical", padding: 10, borderRadius: 8, border: `1px solid ${colors.border}`, background: colors.card, color: colors.text }} />
    ) : (
      <input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} style={{ padding: 10, borderRadius: 8, border: `1px solid ${colors.border}`, background: colors.card, color: colors.text }} />
    )}
  </div>
);

